var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-component"},[_c('div',{staticClass:"alert-box"},[_c('span',{staticClass:"icon"},[_vm._v("⚠")]),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.alertMessage))])])])}
var staticRenderFns = []

export { render, staticRenderFns }